import { Component, Input, Inject } from '@angular/core';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { BaseApplicationSectionsInterface } from '../../../shared/interfaces/base-application-sections.interface';
import { PORTAL_SETTINGS } from '../../../core/token/base-config.token';
import { PortalSettings } from '../../../core/types/base-portal-settings.type';

@Component({
  selector: 'base-application-sections-sidebar',
  templateUrl: './base-application-sections-sidebar.component.html',
})
export class BaseApplicationSectionsSidebarComponent {
  @Input() sections: BaseApplicationSectionsInterface[] = [];
  @Input() areSectionsVisible: boolean = true;

  constructor(private offcanvasService: NgbOffcanvas, @Inject(PORTAL_SETTINGS) private portalConfig: PortalSettings) {}

  get portalSettings(): PortalSettings {
    return this.portalConfig;
  }

  closeSidebar(): void {
    this.offcanvasService.dismiss();
  }
}
